import { z } from 'zod';

// Convience function to parse JSON strings easily
export const safeParse = <T extends z.ZodType>(jsonString: string, schema: T) => {
  try {
    return schema.safeParse(JSON.parse(jsonString));
  } catch (e) {
    return {
      success: false,
      data: undefined,
      error: new z.ZodError([
        {
          code: 'custom',
          input: jsonString,
          path: [],
          message: `JSON parse error: ${e}`,
        },
      ]),
    } satisfies z.ZodSafeParseError<unknown>;
  }
};
